import { useEffect, useState } from 'react'

import Loader from 'react-loaders'

import WordCloud from './wordcloud'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Skills = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const skillsArray = 'Skills'.split('')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container skills-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={skillsArray}
              idx={15}
            />
            <br />
          </h1>
          <p>
            I am a software engineer focused on building impactful, reliable products. 
            My background includes full-stack development, artificial intelligence, and Machine Learning, 
            with an emphasis on creating software that is fast, intuitive, 
             and built for real-world use. I enjoy turning complex ideas into clean, practical solutions.
          </p>
          <p>
            I also care a lot about how great products get built: through strong collaboration,
             clear communication, and a team that works well together. Whether I am leading part
              of a project or supporting the people around me, I aim to bring consistency, ownership,
               and a mindset centered on progress. Here is a list of some of the skills I have developed 
               through my work and projects:

          </p>
        </div>

        <div className="tagcloud-wrap">
          <WordCloud />
        </div>
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Skills
